import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import Cover from "./Cover";
import CheckCircleIcon from "@material-ui/icons/CheckCircle"; // Import the icon
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { useDispatch } from "react-redux";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../../containers/actions/types";
import { fetchTeamAssociates } from "../../../../containers/actions/common/teamMemberAction";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "1em",
  },
  warningBox: {
    padding: "10px",
    border: "2px solid red",
    borderRadius: "4px",
  },
  warningText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "red",
  },
  buttonContainer: {
    // marginTop: "auto",
    position: "absolute",
    bottom: 10,
    width: "90%",
    display: "flex",
    // alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  btnPrimary: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
  // flexContainer: {
  //   display: "flex",
  //   flexDirection: "column",
  //   minHeight: "100vh",
  // },

  // container: {
  //   height: "100%",
  //   display: "flex",
  //   flexDirection: "column",
  //   flexGrow: 1, // Ensures content takes all available space
  //   // backgroundColor: "red",
  // },
  dialog: {
    // Target the dialog root
    "& .MuiPaper-root": {
      borderRadius: "16px", // Rounded corners
      // maxWidth: "90vw", // or 90% of viewport width
    },
  },
  dialogTitle: {
    padding: "24px 24px 0", // Adjust padding
    textAlign: "center", // Center the title
  },
  titleText: {
    // Style the title text
    fontWeight: 600,
    fontSize: "1.5rem", // Adjust as needed
    color: "#212121", // Darker text color
  },
  checkIcon: {
    color: "#008002", // Green color
    fontSize: "3rem", // Large icon size
    marginBottom: "1rem", // Space below icon
  },
  dialogContent: {
    padding: "20px 24px 24px", // Adjust padding
    textAlign: "center", // Center content
  },
  contentText: {
    color: "#424242", // Slightly lighter text
  },
  dialogActions: {
    padding: "16px", // Adjust padding
    justifyContent: "center", // Center the button
  },
  okButton: {
    backgroundColor: "#ec6535", // Orange background
    color: "white", // White text
    textTransform: "none", // Remove uppercase transform
    padding: "8px 30px", // Adjust padding for pill shape
    minWidth: "100px", // optional, set min width for button
    borderRadius: "20px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },
}));

export default function EditAccountStatus({
  setStatusDrawer,
  status,
  setViewDetailsDrawer,
  user,
  handleRefresh,
  selectedRole,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState(status);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const handleUpdate = () => {
    setError(null);
    setLoading(true);
    const url = `${appUrl}/user/updateTeamMemberDetails`;
    axios
      .post(url, [
        {
          saas_user_id: user?.saas_user_id,
          account_status: selectedStatus,
        },
      ])
      .then((res) => {
        // throw new Error("mock Error");
        if (res.data.status) {
          setShowDialog(true);
        } else {
          setError(true);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => setLoading(false));
  };
  const handleOk = () => {
    setStatusDrawer(false);
    setViewDetailsDrawer(false);
    handleRefresh();
    if (selectedRole) {
      dispatch({
        type: FETCH_TEAM_ASSOCIATES_LOADING,
        payload: true,
      });
      dispatch(
        fetchTeamAssociates({
          departmentID: selectedRole.departmentID,
          collaborator_role_id: selectedRole.collaborator_role_id,
          searchString: "all",
          status: "Active",
        })
      );
    }
  };

  // if (loading) return displayLoading;
  // if (error) return displayError;
  return (
    <Box>
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container>
        <Typography variant="h6" className={classes.heading} gutterBottom>
          Edit Account Status
        </Typography>
        <Typography style={{ fontWeight: "bold" }} gutterBottom>
          Status<span style={{ color: "red" }}> *</span>
        </Typography>
        <TextField
          name="accountStatus"
          select
          variant="outlined"
          required
          fullWidth
          size="small"
          value={selectedStatus}
          onChange={handleStatusChange}
        >
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Inactive">Inactive</MenuItem>
        </TextField>
        <Typography
          style={{ marginTop: "2em", fontWeight: 700, fontSize: "18px" }}
        >
          Warning:
        </Typography>
        <Box className={classes.warningBox} style={{ marginTop: "2em" }}>
        <Typography className={classes.warningText}>
            {selectedStatus === "Active"
              ? "Status change: You are changing the user status to active .Team member will gain access to this application. You will have to inactivate the user status to lose access."
              : "Status change: You are changing the user status to inactive .Team member will lose access to this application. You will have to activate the user status to regain access."}
          </Typography>
        </Box>
        {loading ? displayLoading : error ? displayError : null}
        <Box className={classes.buttonContainer}>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setStatusDrawer(false)}
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            className={classes.btnPrimary}
            variant="contained"
            size="small"
            disabled={selectedStatus === status}
            //   color="primary"
            // style={{
            //   textTransform: "none",
            //   backgroundColor: "#286acf",
            //   color: "#fff",
            // }}
            onClick={handleUpdate}
          >
            Update status
          </Button>
        </Box>
        <Dialog
          open={showDialog}
          keepMounted
          onClose={() => setShowDialog(false)}
          className={classes.dialog}
          fullWidth={true}
          maxWidth="sm"
        >
          <DialogTitle className={classes.dialogTitle}>
            <CheckCircleIcon className={classes.checkIcon} />
            <Typography variant="h6" className={classes.titleText}>
              {" "}
              {/* Style the title */}
              Success
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.contentText}>
              Account status updated successfully
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={handleOk}
              className={classes.okButton}
              variant="contained"
              endIcon={<ChevronRightIcon>send</ChevronRightIcon>}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}
